import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { TranslateLoadingService } from '../translate-loading-service';
import { TranslateModel } from '../../models/translate-model';

@injectable()
export class TranslateLoadingServiceImpl implements TranslateLoadingService {
    constructor(
        @inject(TranslateModel)
        private readonly _translateModel: TranslateModel,
    ) {}

    setLoadingTranslateResult(isLoading: boolean): void {
        this._translateModel.update((state) => {
            return {
                ...state,
                isLoadingTranslateResult: isLoading,
            };
        });
    }

    setLoadingRegenerateTranslateFragment(isLoading: boolean): void {
        this._translateModel.update((state) => {
            return {
                ...state,
                isLoadingRegenerateTranslateFragment: isLoading,
            };
        });
    }

    setCurrentTranslateFragmentIndex(index: number): void {
        this._translateModel.update((state) => {
            return {
                ...state,
                currentTranslateFragmentIndex: index,
            };
        });
    }

    setWaitingFirstResponse(waiting: boolean): void {
        this._translateModel.update((state) => {
            return {
                ...state,
                waitingFirstResponse: waiting,
            };
        });
    }
}
